import React, {useCallback, useMemo} from 'react';
import {useSelector} from 'react-redux';

import {groupsTabMembersDataSelector, groupsTabMembersResultSelector} from '../slices/groups-tab-members.slice';

type Props = {
    groupId: number,
    onSelectGroupMembers: (groupId: number) => void,
};

export const MembersCell = ({groupId, onSelectGroupMembers}: Props) => {
    const {isLoading, loadingError} = useSelector(groupsTabMembersDataSelector);
    const result = useSelector(groupsTabMembersResultSelector);

    const count = useMemo(() => result?.data[groupId], [result, groupId]);

    const selectedGroup = useCallback(() => {
        onSelectGroupMembers(groupId);
    }, [groupId, onSelectGroupMembers]);

    if (isLoading || loadingError || count === undefined) {
        return <div/>;
    }

    return (
        <a onClick={selectedGroup}>
            {count}
        </a>
    );
};
